import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Russolo/Russolo.ttf%22}]}],%22variableName%22:%22russolo%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'russolo', 'russolo Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
